import { ProductMessage } from './useAnnouncementBannerForm'

import { useProductMessagesQuery } from '@/graphql/generated/hooks'

/**
 * Return type for useProductMessageForSettings hook
 */
export interface UseProductMessageForSettingsReturnIProps {
  currentMessage: ProductMessage | null
  isLoading: boolean
  error?: Error
}

/**
 * Hook to fetch the most recent product message for the Settings page.
 */
export const useProductMessageForSettings =
  (): UseProductMessageForSettingsReturnIProps => {
    const {
      data: productMessagesData,
      loading: isLoading,
      error,
    } = useProductMessagesQuery({
      variables: {
        filter: {}, // Empty filter = fetch all messages (active and inactive)
        last: 1,
      },
      fetchPolicy: 'cache-and-network',
    })

    const currentMessage = productMessagesData?.productMessages?.[0] ?? null

    return {
      currentMessage,
      isLoading,
      error: error as Error | undefined,
    }
  }
